import { render } from "./ModulePersonalizationBanner.vue?vue&type=template&id=85bc680c&scoped=true"
import script from "./ModulePersonalizationBanner.vue?vue&type=script&lang=js"
export * from "./ModulePersonalizationBanner.vue?vue&type=script&lang=js"

import "./ModulePersonalizationBanner.vue?vue&type=style&index=0&id=85bc680c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85bc680c"]])

export default __exports__